export default __webpack_public_path__ + "static/media/ilus-badge-journeyman.8a839170.svg";